import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=68d0e08e&scoped=true&"
import script from "./Brand.vue?vue&type=script&lang=js&"
export * from "./Brand.vue?vue&type=script&lang=js&"
import style0 from "./Brand.vue?vue&type=style&index=0&id=68d0e08e&prod&lang=scss&scoped=true&"
import style1 from "./Brand.vue?vue&type=style&index=1&id=68d0e08e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d0e08e",
  null
  
)

export default component.exports